import * as ng from 'angular';
import { CassaPrevidenzialeItem } from '../../../../../domain/cassa-previdenziale-item';
import { VATItem } from '../../../../../domain/vat-item';
import { CassaService } from '../../../../../services/data/cassa.service';
import { VATService } from '../../../../../services/data/vat.service';
import { FormService } from '../../../../../services/ui/form.service';
import { NumbersService } from '../../../../../services/ui/numbers.service';

export const CassaPrevidenzialeModalComponent = {
  template: require('./cassa-previdenziale-modal-component.html'),
  controller: class CassaPrevidenzialeModalComponent {

    static $inject: string[] = [
        'CassaService',
        'VATService',
        'FormService',
        'NumbersService',
        '$uibModal',
        '$sce'
    ];

    private tipoCassaType: Record<string, string>;
    private ritenutaType: Record<string, string>;
    private aliquotaIVAType: Array<VATItem>;

    private items: Array<CassaPrevidenzialeItem>;

    private datiCassaPrevidenzialeItem: CassaPrevidenzialeItem;

    private popoverContent: any;

    private resolve: any;
    private close: any;
    private TipoImponibileImporto: { TotaleLinee: string; ValorePersonalizzato: string; };

    constructor(
      private cassaService: CassaService,
      private vatService: VATService,
      private formService: FormService,
      private numbersService: NumbersService,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private $sce: ng.ISCEService
    ) {

      this.TipoImponibileImporto = {
        TotaleLinee: 'Totale Linee',
        ValorePersonalizzato: 'Valore personalizzato'
      };
      this.tipoCassaType = this.cassaService.getItems();
      this.ritenutaType = {
          '': '',
          'SI': 'SI = Cessione / Prestazione soggetta a ritenuta'
      };

      this.aliquotaIVAType = this.vatService.getItems();

      this.items = [];

      this.datiCassaPrevidenzialeItem = {
        TipoCassa: '',
        TipoImponibileImporto: 'TotaleLinee',
        ImponibileImporto: '0.00',
        AlCassa: '0.00',
        ImportoContributoCassa: '0.00',
        ImponibileCassa: '0.00',
        AliquotaIVA: '22.00',
        Ritenuta: '',
        Natura: '',
        RiferimentoAmministrazione: '',
        IVA: '3'
      };

      this.popoverContent = $sce.trustAsHtml(
        '<br/><br/><br/>Da compilare nel caso in cui sei tenuto al versamento del contributo previdenziale alla tua cassa di categoria o all\'INPS (o ad entrambi).<br/>' +
        '<br/>' +
        'Es. 1 professionista iscritto ad una cassa di previdenza di categoria (es. Dottori Commercialisti), con aliquota contributiva del 2% da applicare su un totale compensi di 1600,00 euro e contributo soggetto ad IVA 22% e non soggetto a ritenuta' +
        '<br/><br/>' +
        'Es. 1 <br/>' +
        '<b>Tipo Cassa Previdenziale TC02</b><br/>' +
        '<b>Aliquota % contributo</b>    2.00<br/>' +
        '<b>Importo Contributo Cassa</b> 32.00<br/>' +
        '<br/>');
    }

    $onInit(): void {
      const resolvedItems = this.resolve.items;
      for (let i = 0; i < resolvedItems.length; i++) {
        this.items.push(jQuery.extend(true, {}, resolvedItems[i]));
      }
    }

    selectIva(item: CassaPrevidenzialeItem) {
      let indexes = $.map(this.aliquotaIVAType, (obj, index) => {
        if (obj['data-id'] === item.IVA) {
          return index;
        }
      });
      if (indexes.length === 1) {
        item.AliquotaIVA = this.aliquotaIVAType[indexes[0]]['data-value'];
        item.Natura = this.aliquotaIVAType[indexes[0]]['data-natura'];
      }
    }

    aggiungiCassaPrevidenziale() {
      this.items.push(jQuery.extend(true, {}, this.datiCassaPrevidenzialeItem));
    }

    rimuoviCassaPrevidenziale(index: number) {
      let modalInstance = this.$uibModal.open({
        component: 'defaultModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          config: () => {
            return {
              headerIcon: 'fa fa-exclamation-triangle',
              headerText: 'Attenzione',
              bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare Cassa Previdenziale?',
              buttons: [
                {
                  'id': 1,
                  'icon': 'fa fa-ban',
                  'label': 'Annulla'
                },
                {
                  'id': 2,
                  'icon': 'fa fa-check-circle-o',
                  'label': 'Si'
                }
              ]
            };
          }
        }
      });
      modalInstance.result.then((pressedButtonId) => {
        if (pressedButtonId !== undefined) {
          if (pressedButtonId === 1) {
            // ??
          }
          if (pressedButtonId === 2) {
            this.items.splice(index, 1);
          }
        }
      }, () => {
        // ?
      });
    }

    save(errors: any) {
      if ($.isEmptyObject(errors)) {
        this.close({ $value: this.items });
      } else {
        this.formService.setErrorFieldsTouched(errors);
        $('[name=\'form\']').find('.ng-invalid:visible:first').focus();
      }
    }

    cancel() {
      this.close();
    }
  },
  bindings: {
      resolve: '<',
      close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/cassa-previdenziale-modal-component/cassa-previdenziale-modal-component.ts